import { Avatar, Typography, useMediaQuery, useTheme } from "@material-ui/core"
import PropTypes from "prop-types"
import React, { useContext } from "react"
import HoverText from "~/components/Common/HoverText"
import PaperListRow from "~/components/Common/PaperListRow"
import AppContext from "~/contexts/App"
import InstructorsContext from "~/contexts/Instructors"

import Box from "~/components/Common/Box"
import useStyles from "./styles"

const InstructorCard = ({ name, title, profileImg, bio, id }) => {
  const { openDialog } = useContext(AppContext)
  const { updateInstructorMutation } = useContext(InstructorsContext)

  //sends the id that was clicked along with the updateInstructor function
  const handleClick = (id) => {
    openDialog("editInstructorDialog", {
      id: id,
      update: updateInstructorMutation,
    })
  }

  const classes = useStyles()
  const theme = useTheme()
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    <Box
      marginBottom="16px"
      style={{ cursor: "pointer" }}
      onClick={() => handleClick(id)}
    >
      <PaperListRow componentHeight={smScreen ? "96px" : "64px"}>
        <Box className={classes.avatar}>
          <Avatar src={profileImg} className={classes.profileImage} />
        </Box>
        <Box className={classes.infoContainer} width="85%">
          <Box width={smScreen ? "100%" : "20%"}>
            <Typography
              variant="h3"
              style={{ fontWeight: 600 }}
              color="primary"
            >
              {name}
            </Typography>
          </Box>
          <Box width={smScreen ? "100%" : "25%"}>
            <HoverText
              data={title}
              size={smScreen ? 25 : 40}
              variant="subtitle1"
            />
          </Box>
          <Box width={smScreen ? "100%" : "55%"} className={classes.bioBox}>
            <HoverText
              data={bio}
              size={smScreen ? 60 : 95}
              variant="subtitle1"
            />
          </Box>
        </Box>
      </PaperListRow>
    </Box>
  )
}

InstructorCard.propTypes = {
  name: PropTypes.string,
  title: PropTypes.string,
  profileImg: PropTypes.string,
  bio: PropTypes.string,
  id: PropTypes.number,
}

export default InstructorCard
